import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { TranslatedToastService } from '../../_services/translated-toast.service';
import { SharedService } from '../../_services/shared.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { TeamsService } from '../../_services/teams.service';
import { SitesService } from '../../_services/sites.service';
import { ResourceTypes } from '../../_enums/resourceTypes';
import { TableDataService } from '../../_services/table-data.service';
import { DeleteSiteOptionsDto } from '../../_dtos/deleteSiteOptionsDto';
import { ServersService } from '../../_services/servers.service';
import { BookingsService } from '../../_services/bookings.service';

@Component({
  selector: 'app-delete-resource-form',
  imports: [TranslateModule, MatButton],
  standalone: true,
  templateUrl: './delete-resource-form.component.html',
  styleUrl: './delete-resource-form.component.css',
})
export class DeleteResourceFormComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  private id!: string;
  public displayName!: string;
  private resourceType!: ResourceTypes;
  private isGroupConnected!: boolean;
  private connectedGroupId!: string;

  constructor(
    private toastr: TranslatedToastService,
    private sharedService: SharedService,
    private teamsService: TeamsService,
    private sitesService: SitesService,
    private serversService: ServersService,
    private bookingsService: BookingsService,
    private tableDateService: TableDataService,
  ) {}

  ngOnInit() {
    this.sharedService.deleteForm$.subscribe((value) => {
      this.displayName = value!.displayName ?? '';
      this.id = value!.id ?? '';
      this.resourceType = value!.resourceType ?? '';
      this.isGroupConnected = value!.isGroupConnected ?? false;
      this.connectedGroupId = value!.connectedGroupId ?? '';
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  deleteResource() {
    this.sharedService.closeModal();
    if (this.resourceType === ResourceTypes.TEAM) {
      this.teamsService.deleteTeams(this.id).subscribe({
        next: async () => {
          await this.toastr.show(
            'success',
            'TOASTS.RESOURCE.DELETED_MESSAGE',
            'TOASTS.RESOURCE.DELETED_TITLE',
          );
          this.tableDateService.notifyResourceDelete(this.id);
        },
      });
    }

    if (this.resourceType === ResourceTypes.SHAREPOINT) {
      // Special Case for BernieBot Sites (which do have a connected M365Group)
      if (this.isGroupConnected) {
        var deleteSiteOptions: DeleteSiteOptionsDto = {
          siteId: this.id,
          isGroupConnected: this.isGroupConnected,
        };
        this.teamsService
          .deleteTeams(this.connectedGroupId, deleteSiteOptions)
          .subscribe({
            next: async () => {
              await this.toastr.show(
                'success',
                'TOASTS.RESOURCE.DELETED_MESSAGE',
                'TOASTS.RESOURCE.DELETED_TITLE',
              );
              this.tableDateService.notifyResourceDelete(this.id);
            },
          });
        // Standard Site Deletion
      } else {
        this.sitesService.deleteSharepoint(this.id).subscribe({
          next: async () => {
            await this.toastr.show(
              'success',
              'TOASTS.RESOURCE.DELETED_MESSAGE',
              'TOASTS.RESOURCE.DELETED_TITLE',
            );
            this.tableDateService.notifyResourceDelete(this.id);
          },
        });
      }
    }
    // Server Deletion
    if (this.resourceType === ResourceTypes.SERVER) {
      this.serversService.deleteServer(this.id).subscribe({
        next: async () => {
          await this.toastr.show(
            'success',
            'TOASTS.RESOURCE.DELETED_MESSAGE',
            'TOASTS.RESOURCE.DELETED_TITLE',
          );
          this.tableDateService.notifyResourceDelete(this.id);
        },
      });
    }
    if (this.resourceType === ResourceTypes.BOOKINGS) {
      this.bookingsService.deleteBooking(this.id).subscribe({
        next: async () => {
          await this.toastr.show(
            'success',
            'TOASTS.RESOURCE.DELETED_MESSAGE',
            'TOASTS.RESOURCE.DELETED_TITLE',
          );
          this.tableDateService.notifyResourceDelete(this.id);
        },
      });
    }
  }

  closeModal() {
    this.sharedService.closeModal();
  }
}
